export const APP_VERSION = '5.5.39'
